<template>
    <div class="modal-overlay" @click="$emit('close')">
        <div class="modal" ref="myBtn" @click="$emit('close')">
            <button class="styleBtnClose" @click="$emit('close-modal')">
                <font-awesome-icon class="" :icon="['fas', 'times']" size="lg"/>
            </button>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <iframe id="Geeks3"
                                :src="video"
                                frameborder="0" allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'preview-component',
        props: ['video'],
        data(){
            return {
                state: false
            }
        },
        methods:{
            confirmHandler(){
                this.$emit('close-modal', true)
            },
            cancleHandler(){
                this.$emit('close-modal', false)
            }
        }

    }
</script>

<style scoped>
    .styleBtnClose{
        position: absolute;
        right: -58px;
        top:-7px;
        background: transparent;
        border: none;
        z-index:9999;
    }
    .styleBtnClose:hover{
        background: transparent;
        color: #e95626;
    }
    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000;
        z-index: 100;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: relative !important;
        background-color: #032A3A;
        height: 70%;
        border-radius: 20px;
        margin: auto;
        width: 80%;
        overflow-y: hidden;
        border: 2px solid #fff;
    }

    .modal-body{
        position: relative;
        right: 300px;
    }

    .modal-content{
        background-color: transparent;
    }

    #Geeks3{
        width:1050px;
        height: 600px;
    }

    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .confirm-btn{
        background-color: #e65c00;
        border: 1px solid transparent;
    }
    .cancle-btn{
        background-color: transparent;
        color: #e65c00;
        border: 1px solid #e65c00;
    }
</style>